import React, { useState, useEffect } from "react";
//import { motion } from "framer-motion";

import studentImg from "../images/dashboard_student.png"; // gambar siswa
import pathsImg from "../images/dashboard_paths.png";   // gambar panah

const Dashboard = () => {
    // State untuk menyimpan progres saat ini
    const [lsProgress, setLsProgress] = useState(null); 
    // >>>State untuk Teaching Experience Progress <<<
    const [teProgress, setTeProgress] = useState(null); 
    const [studentData, setStudentData] = useState(null);
	// >>>State untuk Digital Readiness Progress <<<
	const [drProgress, setDrProgress] = useState(null); 

    // --- 1. AMBIL PROGRES DARI LOCALSTORAGE SAAT KOMPONEN DIMUAT ---
    useEffect(() => {
        try {
            const student = JSON.parse(localStorage.getItem("student"));
            if (student) {
                setStudentData(student);
                setLsProgress(student.ls_current_step);
                // >>> BARU: Baca progres Teaching Experience <<<
                setTeProgress(student.te_current_step);
				setDrProgress(student.dr_current_step);
            } else {
                // Jika student tidak ada, asumsikan '1' (belum mulai)
                setLsProgress('1'); 
                // >>> BARU <<<
                setTeProgress('1');
				setDrProgress('1');
            }
        } catch (e) {
            console.error("Error reading student data from localStorage:", e);
            setLsProgress('1');
            // >>> BARU <<<
            setTeProgress('1');
			setDrProgress('1');
        }
    }, []);

    // --- FUNGSI PENANGANAN KLIK CERDAS (Learning Style - TETAP) ---
    const handleLearningStyleClick = () => {
        if (!lsProgress || lsProgress === '1') {
            window.location.href = "/learning-style/hello-style";
        } else if (lsProgress === 'done') {
            window.location.href = "/learning-style/summary";
        } else {
            window.location.href = `/learning-style/style${lsProgress}`;
        }
    };

    // Fungsi helper untuk menampilkan status di tombol (LS - TETAP)
    const getLsStatusText = () => {
        if (lsProgress === 'done') {
            return " (Completed! ✅)";
        }
        if (lsProgress && lsProgress !== '1') {
            return ` (Continue ${lsProgress}..)`;
        }
        return "";
    };

    // --- 2. BARU: FUNGSI PENANGANAN KLIK CERDAS UNTUK TEACHING EXPERIENCE ---
    const handleTeachingExperienceClick = () => {
        if (!teProgress || teProgress === '1') {
            // Jika belum ada progres atau masih di step 1, masuk ke halaman intro
            window.location.href = "/teaching-experience/hello"; // <<< ROUTE INTRO BARU
        } else if (teProgress === 'done') {
            // Jika sudah selesai
            window.location.href = "/teaching-experience/summary";
        } else {
            // Jika ada progres (misal: '2', '3', '4'), langsung ke Exp yang belum selesai
            window.location.href = `/teaching-experience/exp${teProgress}`; // <<< ROUTE EXP BARU
        }
    };
    
    // BARU: Fungsi helper untuk menampilkan status di tombol TE
    const getTeStatusText = () => {
        if (teProgress === 'done') {
            return " (Completed! ✅)";
        }
        if (teProgress && teProgress !== '1') {
            // Asumsi Exp1 = step 1. Jika di step 2, maka tulis '2'
            return ` (Continue ${teProgress}..)`; 
        }
        return "";
    };
	
	   // --- 2. BARU: FUNGSI PENANGANAN KLIK CERDAS UNTUK DIGITAL READINESS ---
    const handleDigitalReadinessClick = () => {
        if (!drProgress || drProgress === '1') {
            // Jika belum ada progres atau masih di step 1, masuk ke halaman intro
            window.location.href = "/digital-readiness/HelloDR"; // <<< ROUTE INTRO BARU
        } else if (drProgress === 'done') {
            // Jika sudah selesai
            window.location.href = "/digital-readiness/summaryDR";
        } else {
            // Jika ada progres (misal: '2', '3', '4'), langsung ke Exp yang belum selesai
            window.location.href = `/digital-readiness/exp${drProgress}`; // <<< ROUTE EXP BARU
        }
    };
    
    // BARU: Fungsi helper untuk menampilkan status di tombol DR
    const getDrStatusText = () => {
        if (drProgress === 'done') {
            return " (Completed! ✅)";
        }
        if (drProgress && drProgress !== '1') {
            // Asumsi Exp1 = step 1. Jika di step 2, maka tulis '2'
            return ` (Continue ${drProgress}..)`; 
        }
        return "";
    };



    return (
        <div className="min-h-screen bg-gradient-to-b from-blue-900 via-blue-700 to-blue-500 text-white relative px-6 flex flex-col items-center">
            
            {/* ... (Title, Welcome, Paths/Student Image) ... */}
            <h1 className="text-4xl md:text-4xl font-bold text-center mt-5 drop-shadow-lg text-yellow-300">
                Let’s make this fun!
            </h1>
			
			{studentData && (
                <p className="text-xl font-small text-center text-yellow-100">
                    Welcome back, {studentData.name || "Student"}!
                </p>
            )}
			
			<h2 className="text-lg md:text-xl font-normal text-center mt-2 text-blue-200">
                Choose your path
            </h2>
			
			 {/* Content Area */}
            <div className="relative mt-10 w-full max-w-4xl flex justify-center">

                {/* Paths / Branch Image */}
                <img
                    src={pathsImg}
                    alt="paths"
                    className="absolute left-3/4 transform -translate-x-1/2 w-[280px] md:w-[310px] mt-4 opacity-90"
                />

                {/* Student Image */}
                <img
                    src={studentImg}
                    alt="student"
                    className="w-[100px] md:w-[400px] drop-shadow-xl"
                />

            {/* BUTTON AREAS */}

            {/* Teaching Experiences */}
            <button
                onClick={handleTeachingExperienceClick} // Ganti dengan handler cerdas BARU
                className="absolute top-[155px] right-[25px] md:right-[1px] text-white font-semibold hover:text-yellow-300 transition-colors"
            >
                Teaching Experience
                <span className="text-yellow-300 text-sm font-semibold">
                    {getTeStatusText()} {/* Tampilkan status progres BARU */}
                </span>
            </button>

            {/* English Proficiency (TETAP) */}
            <button
                onClick={() => (window.location.href = "/english-proficiency")}
                className="absolute top-[30px] right-[25px] md:right-[50px] text-white font-semibold hover:text-yellow-300"
            >
                English Proficiency
            </button>
            
            {/* Digital Readiness (TETAP) */}
           <button
                onClick={handleDigitalReadinessClick} // Ganti dengan handler cerdas BARU
                className="absolute top-[235px] right-[25px] md:right-[0px] text-white font-semibold hover:text-yellow-300 transition-colors"
            >
                Digital Readiness
                <span className="text-yellow-300 text-sm font-semibold">
                    {getTeStatusText()} {/* Tampilkan status progres BARU */}
                </span>
            </button>


            {/* Learning Style (Menggunakan fungsi cerdas - TETAP) */}
            <button
                onClick={handleLearningStyleClick} 
                className="absolute top-[95px] left-[200px] md:right-[1px] text-white font-semibold hover:text-yellow-300 transition-colors"
            >
                Learning Style
                <span className="text-yellow-300 text-sm font-semibold">
                    {getLsStatusText()}
                </span>
            </button>

            {/* Independent Learning (TETAP) */}
            <button
                onClick={() => (window.location.href = "/independent-learning")}
                className="absolute top-[310px] left-[170px] md:left-[620px] text-white font-semibold hover:text-yellow-300"
            >
                Independent Learning
            </button>
		</div>
			 
            {/* ... (Footer) ... */}
			<p className="absolute bottom-4 text-blue-200 text-xs">
                © 2025 Universitas Terbuka
            </p>

        </div>
    );
};

export default Dashboard;